module.exports = __webpack_public_path__ + "media/assets/images/column-thumbnail_cancer-bed1e5c0c1370f482497dc71f380d8b0.png";